import React, { useCallback } from 'react'
import SeedClassDetailsForm, { FormData } from './SeedClassDetailsForm/SeedClassDetailsForm'
import * as Layout from 'views/layouts/MainLayout/MainLayout'
import * as Header from 'views/ui/Header/Header'
import SeedClassActions from 'modules/domain/seedClass/duck'
import SeedClassSelectors from 'modules/domain/seedClass/selectors'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import SeedClassRoutes from 'views/pages/SeedClass/routes'
import { useAction, useHelmet, useHistoryPush } from '@agro-club/frontend-shared'

const SeedClassAdd: React.FC = () => {
  const { t } = useTranslation('seedClass')
  const push = useHistoryPush()
  const seedClassAddAction = useAction(SeedClassActions.addRequested)
  const page = useSelector(SeedClassSelectors.page)

  const handleSubmit = useCallback(
    (fields: Required<FormData>) => {
      seedClassAddAction({
        name: fields.name,
        crop_id: fields.crop_id,
      })
    },
    [seedClassAddAction],
  )

  const goBack = () => push({ route: SeedClassRoutes.List, query: { page } })
  const progress = useSelector(SeedClassSelectors.addProgress)

  useHelmet({ title: t('addSeedClassMetaTitle') })

  return (
    <>
      <Layout.Header>
        <Header.Root onClickBack={goBack}>
          <Header.Title size={'large'} title={t('form.add')} />
        </Header.Root>
      </Layout.Header>
      <Layout.Content>
        <SeedClassDetailsForm onCancel={goBack} mode={'create'} onSubmit={handleSubmit} progress={progress} />
      </Layout.Content>
    </>
  )
}

export default SeedClassAdd
